import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledGolfBioCardsContainer = styled.div`
  padding-top: ${toRem(32)};
  padding-bottom: ${toRem(32)};

  .bio-cards-container {
    row-gap: ${toRem(32)};
  }
`;
